import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "location",
  "use": "location-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"location\">\n<path d=\"M10 1.65412e-08C4.48603 7.42044e-09 5.17024e-06 4.48561 1.15258e-05 9.99955C1.78818e-05 15.5139 4.48605 19.9999 10 19.9999C15.514 19.9999 20 15.5139 20 9.99955C20 4.48601 15.514 2.5662e-08 10 1.65412e-08ZM4.47521 15.5237L7.3131 8.7751L11.2249 12.6858L4.47521 15.5237ZM12.6931 11.2082L8.79029 7.3065L15.524 4.47557L12.6931 11.2082Z\" fill=\"#233142\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol